<div
	[attr.role]="alt ? 'img' : null"
	[attr.aria-label]="alt || null"
	[attr.aria-hidden]="alt ? null : 'true'"
	[class.sb-svg-loading]="!svgContent"
	[style.height.px]="!svgContent ? height : null"
	[style.width.px]="!svgContent ? height : null"
	[innerHTML]="svgContent | trustHtml"></div>
